import { render, staticRenderFns } from "./DecisionCommitteeEditModal.vue?vue&type=template&id=e812ecf0&scoped=true"
import script from "./DecisionCommitteeEditModal.vue?vue&type=script&lang=js"
export * from "./DecisionCommitteeEditModal.vue?vue&type=script&lang=js"
import style0 from "./DecisionCommitteeEditModal.vue?vue&type=style&index=0&id=e812ecf0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e812ecf0",
  null
  
)

export default component.exports